// Static data for millet-vs-X comparisons used in /why-millets and home
export const COMPARISONS = [
  {
    slug: "millet-vs-wheat",
    blogSlug: "millet-vs-wheat",
    competitor: "Wheat",
    accent: "#f2cd1a",
    milletWins: [
      "Naturally gluten-free",
      "Lower glycemic index — steadier energy",
      "Higher iron & magnesium per 100g",
      "Grows on 1/3 the water wheat needs",
    ],
    competitorIssues: [
      "Contains gluten (inflammatory for many)",
      "Spikes blood sugar faster",
      "Heavily refined into white flour",
      "Thirsty, intensive monoculture",
    ],
    verdict:
      "Millet is what wheat was before we stripped it, bleached it, and sold it back to you.",
  },
  {
    slug: "millet-vs-oats",
    blogSlug: "millet-vs-oats",
    competitor: "Oats",
    accent: "#FF4200",
    milletWins: [
      "Higher protein (11g vs 10.6g per 100g)",
      "Gluten-free by default (oats are cross-contaminated)",
      "More diverse amino acid profile",
      "Ancient, unmodified grain",
    ],
    competitorIssues: [
      "Cross-contamination risk for celiacs",
      "Mostly sold as sugared instant packets",
      "Heavier on water than millet",
      "Harder to grow in hot climates",
    ],
    verdict:
      "Oats are great. Millet is quietly greater — and drinks less water doing it.",
  },
  {
    slug: "millet-vs-almond",
    blogSlug: "millet-vs-almond",
    competitor: "Almond",
    accent: "#ff4200",
    milletWins: [
      "~12x less water per litre of milk",
      "Grows on marginal, rain-fed land",
      "Nut-free — safe for allergic families",
      "Delivers real iron & B-vitamins",
    ],
    competitorIssues: [
      "1 almond ≈ 3.2L of water",
      "Monoculture pressure on bee populations",
      "Nut allergen risk",
      "Mostly water + thickener in the carton",
    ],
    verdict:
      "Almond milk is mostly water. Millet milk is mostly millet.",
  },
  {
    slug: "millet-vs-corn",
    blogSlug: "millet-vs-corn",
    competitor: "Corn",
    accent: "#41c1f6",
    milletWins: [
      "Whole-grain by default — not refined syrup",
      "Higher protein & lower starch",
      "No GMO commodity supply chain",
      "Naturally drought-tolerant",
    ],
    competitorIssues: [
      "Most corn ends up as HFCS or feed",
      "Heavily GMO + pesticide-dependent",
      "Low protein, high glycemic load",
      "Soil-depleting in monoculture",
    ],
    verdict:
      "Corn built the snack aisle. Millet is building what's next.",
  },
  {
    slug: "millet-vs-soy",
    blogSlug: "millet-vs-soy",
    competitor: "Soy",
    accent: "#E7100E",
    milletWins: [
      "Allergen-free for most people",
      "No phyto-estrogen debates",
      "Lighter digestion for sensitive stomachs",
      "Lower water + land footprint",
    ],
    competitorIssues: [
      "One of the top 8 food allergens",
      "Major deforestation driver in the Amazon",
      "Highly GMO-dominated market",
      "Processing-heavy (isolate, lecithin, etc.)",
    ],
    verdict:
      "Soy fed a generation. Millet is for the one asking better questions.",
  },
  {
    slug: "millet-vs-whey-protein",
    blogSlug: "millet-vs-whey-protein",
    competitor: "Whey Protein",
    accent: "#1d168f",
    darkHeader: true,
    milletWins: [
      "Plant-based, lactose-free",
      "Whole-food — not a lab isolate",
      "Fiber + micronutrients included",
      "Gentler on gut and kidneys",
    ],
    competitorIssues: [
      "Dairy-derived — lactose issues",
      "Often loaded with artificial sweeteners",
      "Isolate = stripped of everything else",
      "Acne & bloating complaints common",
    ],
    verdict:
      "Whey is a powder. Millet is a meal that happens to build muscle too.",
  },
];
